export default __webpack_public_path__ + "static/media/hero-image-1@2x.ce55f668.png";